export const TrTextArea = (props) => {
    const {id, placeholder, onChange, isAlert} = props;

    const nomarlCss = "border border-grey h-44 w-full resize-none";
    const alertCss = "border border-red-400 bg-red-100 h-44 w-full resize-none";

    return (
        <>
            <tr><td><textarea id={id} placeholder={placeholder} className={!isAlert ? nomarlCss : alertCss} onChange={onChange}/></td></tr>
        </>
    );
};